export default __webpack_public_path__ + "static/media/pinnedon.18dad066.svg";